import { InjectivePermissionsV1Beta1Permissions as PermissionProto } from '@injectivelabs/core-proto-ts';
export const PermissionActionMap = PermissionProto.Action;
